<blockable-div id="facility-details" #details>
  <app-progress-spinner [enabled]="!facility" />
  <p-blockUI
    [blocked]="saving === true || loading === true"
    [target]="details"
  />
  @if (facility) {
    <div>
      <form [formGroup]="form!" id="facility-create-form">
        <div id="facility-action-buttons-form">
          <div class="button-header">
            <div>
              <app-progress-spinner [enabled]="saving" />
            </div>
            @if (facility.id && actions.length > 0) {
              <div class="input">
                <span class="label"
                  >{{ 'COMMON.LABEL.ACTIONS' | translate }}:</span
                >
                <span class="align-left">
                  <p-select
                    [options]="actions"
                    (onChange)="actionEvent($event, dd)"
                    [(ngModel)]="selectedAction"
                    [ngModelOptions]="{ standalone: true }"
                    scrollHeight="calc(100vh - 35vh)"
                    styleClass="action-drop-down"
                    #dd
                  />
                </span>
              </div>
            }
            @if (
              (canEdit ||
                canCreate ||
                canAddContactListToFacility ||
                canRemoveContactListFromFacility) &&
              isEditting &&
              !this._deviceService.isMobile()
            ) {
              <button
                pButton
                label="{{ 'COMMON.LABEL.BUTTONS.SAVE' | translate }}"
                icon="fa fa-fw fa-save"
                (click)="saveFacility()"
                [disabled]="this.form!.invalid || saving"
              ></button>
            }
            @if (
              canEdit && isEditting === false && !this._deviceService.isMobile()
            ) {
              <button
                pButton
                label="{{ 'COMMON.LABEL.BUTTONS.EDIT' | translate }}"
                icon="fa fa-fw fa-save"
                (click)="setEditting(true)"
              ></button>
            }
          </div>
          <hr id="facility-scroll-divider" />
          <div>
            <div class="row details-row-1">
              <div class="row-item">
                <span class="label"
                  >{{ 'LOCATION.LABEL.FACILITY_NAME' | translate }}:<span
                    class="required"
                    >*</span
                  ></span
                >
                <span class="row-input">
                  <input
                    type="text"
                    pInputText
                    class="ui-inputtext ui-widget ui-state-default ui-corner-all ui-autocomplete-input facility-name"
                    formControlName="facilityName"
                  />
                </span>
              </div>
              <div class="row-item">
                <span class="label"
                  >{{ 'LOCATION.LABEL.FACILITY_UID' | translate }}:<span
                    class="required"
                    >*</span
                  ></span
                >
                <span class="row-input">
                  <input
                    type="text"
                    pInputText
                    class="ui-inputtext ui-widget ui-state-default ui-corner-all ui-autocomplete-input"
                    formControlName="facilityUid"
                    size="10"
                  />
                </span>
              </div>
              <div class="row-item">
                <span class="label"
                  >{{ 'LOCATION.LABEL.FLOC' | translate }}:</span
                >
                <span class="row-input">
                  <input
                    type="text"
                    pInputText
                    class="ui-inputtext ui-widget ui-state-default ui-corner-all ui-autocomplete-input"
                    formControlName="flocNumber"
                  />
                </span>
              </div>
              <div class="row-item">
                <span class="label"
                  >{{ 'LOCATION.LABEL.FACILITY_TYPE' | translate }}:<span
                    class="required"
                    >*</span
                  ></span
                >
                <span class="row-input">
                  <p-select
                    [options]="types"
                    formControlName="facilityType"
                    [style]="{ width: '13vw' }"
                    [virtualScroll]="true"
                    [virtualScrollItemSize]="30"
                  />
                </span>
              </div>
              <div class="row-item checkboxes">
                <label>{{
                  'LOCATION.LABEL.HIDDEN_FACILITY' | translate
                }}</label>
                <p-checkbox
                  class="checkbox"
                  formControlName="hidden"
                  value="Hidden Facility"
                  [binary]="true"
                />
                <label>{{ 'LOCATION.LABEL.AUTO_SIGN_OUT' | translate }}</label>
                <p-checkbox
                  class="checkbox"
                  formControlName="autoSignout"
                  [binary]="true"
                />
              </div>
            </div>
            <div class="row details-row-2">
              <div class="row-item">
                <span class="label"
                  >{{ 'LOCATION.LABEL.AOR' | translate }}:<span class="required"
                    >*</span
                  ></span
                >
                <span class="row-input ui-fluid aor-input">
                  <!-- Removed virtual scroll from this select due to it causing "bouncing" issues
                       and the various solutions we tried from https://github.com/orgs/primefaces/discussions/353
                       did not solve the problem, and we have a limited number of AORs here anyway
                  -->
                  <p-multiSelect
                    [options]="availableAORs"
                    formControlName="aors"
                  />
                </span>
              </div>
              <div class="row-item">
                <span class="label"
                  >{{ 'LOCATION.LABEL.REGION' | translate }}:</span
                >
                <span class="row-input">
                  <p-autoComplete
                    [suggestions]="filteredRegions"
                    formControlName="region"
                    (completeMethod)="regionSearch($event)"
                    (onSelect)="selectRegion($event)"
                    [dropdown]="true"
                    optionLabel="label"
                    optionValue="value"
                    appendTo="body"
                  />
                </span>
              </div>
              <div class="row-item">
                <span class="label"
                  >{{ 'LOCATION.LABEL.AREA' | translate }}:</span
                >
                <span class="row-input">
                  <p-autoComplete
                    [suggestions]="filteredAreas"
                    (completeMethod)="areaSearch($event)"
                    (onSelect)="areaSelected($event)"
                    formControlName="area"
                    [dropdown]="true"
                    optionLabel="label"
                    optionValue="value"
                    appendTo="body"
                  />
                </span>
              </div>
              <div class="row-item">
                <span class="label"
                  >{{ 'LOCATION.LABEL.PRIMARY_EMPLOYEE' | translate }}:</span
                >
                <span class="row-input">
                  <p-autoComplete
                    [suggestions]="filteredContacts"
                    (completeMethod)="contactSearch($event)"
                    formControlName="owner"
                    [dropdown]="true"
                    optionLabel="label"
                    optionValue="value"
                    appendTo="body"
                    [virtualScroll]="true"
                    [virtualScrollItemSize]="34"
                  />
                </span>
              </div>
              <div class="row-item">
                <span class="label"
                  >{{ 'LOCATION.LABEL.PHONE' | translate }}:</span
                >
                <span
                  class="row-input"
                  [style]="{ 'min-width': 'calc(100% - 2vw)' }"
                >
                  <p-inputMask
                    mask="999-999-9999"
                    id="phone"
                    formControlName="phone"
                    (onBlur)="fixMask('phone')"
                  />
                  @if (this.form!.controls['phone'].value && !isEditting) {
                    <a href="tel:9-1-{{ this.form!.controls['phone'].value }}">
                      <button
                        type="button"
                        pButton
                        icon="fa fa-phone"
                        pTooltip="Call {{ this.form!.controls['phone'].value }}"
                        class="call-contact-btn"
                      ></button>
                    </a>
                  }
                </span>
              </div>
              <div class="row-item">
                <span class="label"
                  >{{ 'LOCATION.LABEL.ALT_PHONE' | translate }}:</span
                >
                <span
                  class="row-input"
                  [style]="{ 'min-width': 'calc(100% - 2vw)' }"
                >
                  <p-inputMask
                    mask="999-999-9999"
                    id="phone"
                    formControlName="altPhone"
                    (onBlur)="fixMask('altPhone')"
                  />
                  @if (this.form!.controls['altPhone'].value && !isEditting) {
                    <a
                      href="tel:9-1-{{ this.form!.controls['altPhone'].value }}"
                    >
                      <button
                        type="button"
                        pButton
                        icon="fa fa-phone"
                        pTooltip="Call {{
                          this.form!.controls['altPhone'].value
                        }}"
                        class="call-contact-btn"
                      ></button>
                    </a>
                  }
                </span>
              </div>
            </div>
            <div class="row details-row-3">
              <div class="row-item" (click)="toggleLocationsDialog('State')">
                <span class="label"
                  >{{ 'LOCATION.LABEL.STATE' | translate }}:</span
                >
                <span class="row-input" style="cursor: pointer">
                  <p [style]="{ display: 'table-cell' }">
                    @let stateList = getStateListForDisplay();
                    @if (stateList !== '') {
                      {{ stateList }}
                    } @else {
                      {{ 'LOCATION.LABEL.ADD_STATE' | translate }}
                    }
                  </p>
                </span>
              </div>
              <div class="row-item" (click)="toggleLocationsDialog('County')">
                <span class="label"
                  >{{ 'LOCATION.LABEL.COUNTY' | translate }}:</span
                >
                <span class="row-input" style="cursor: pointer">
                  <p [style]="{ display: 'table-cell' }">
                    @let countyList = getCountyListForDisplay();
                    @if (countyList !== '') {
                      {{ countyList }}
                    } @else {
                      {{ 'LOCATION.LABEL.ADD_COUNTY' | translate }}
                    }
                  </p>
                </span>
              </div>
              <div class="row-item" (click)="toggleLocationsDialog('Township')">
                <span class="label"
                  >{{ 'LOCATION.LABEL.TOWNSHIP' | translate }}:</span
                >
                <span class="row-input" style="cursor: pointer">
                  <p [style]="{ display: 'table-cell' }">
                    @let townshipList = getTownshipListForDisplay();
                    @if (townshipList !== '') {
                      {{ townshipList }}
                    } @else {
                      {{ 'LOCATION.LABEL.ADD_TOWNSHIP' | translate }}
                    }
                  </p>
                </span>
              </div>
              <div class="row-item">
                <span class="label"
                  >{{ 'LOCATION.LABEL.GPS' | translate }}:</span
                >
                <span class="row-input">
                  <input
                    type="text"
                    pInputText
                    class="ui-inputtext ui-widget ui-state-default ui-corner-all ui-autocomplete-input"
                    formControlName="gps"
                  />
                </span>
              </div>
              <div class="row-item">
                <span class="label"
                  >{{ 'LOCATION.LABEL.ADDRESS' | translate }}:</span
                >
                <span class="row-input">
                  <input
                    type="text"
                    pInputText
                    class="ui-inputtext ui-widget ui-state-default ui-corner-all ui-autocomplete-input"
                    formControlName="address"
                  />
                </span>
              </div>
              <div class="row-item">
                <span class="label"
                  >{{ 'LOCATION.LABEL.LOCAL_TIME' | translate }}:</span
                >
                <span class="row-input">
                  <p [style]="{ display: 'table-cell' }">{{ localTime }}</p>
                </span>
              </div>
            </div>
            @if (isEditting) {
              <div class="row details-row-4">
                <div class="row-item">
                  <span class="label"
                    >{{ 'COMMON.LABEL.BUSINESS_UNITS' | translate }}:<span
                      class="required"
                      >*</span
                    ></span
                  >
                  <span class="row-input">
                    <p-select
                      [options]="availableBusinessUnits"
                      formControlName="businessUnit"
                      [style]="{ width: 'inherit' }"
                    />
                  </span>
                </div>
                <div class="row-item">
                  <span class="label"
                    >{{ 'LOCATION.LABEL.COMPANY' | translate }}:<span
                      class="required"
                      >*</span
                    ></span
                  >
                  <span class="row-input" id="company-input">
                    <p-select
                      [options]="availableCompanies"
                      formControlName="company"
                      [style]="{ width: '99%' }"
                      [virtualScroll]="true"
                      [virtualScrollItemSize]="30"
                    />
                  </span>
                </div>
                <div class="row-item">
                  <span class="label"
                    >{{ 'LOCATION.LABEL.TIMEZONE' | translate }}:</span
                  >
                  <span class="row-input">
                    <p-select
                      formControlName="timezone"
                      [options]="timeZones"
                      optionLabel="label"
                      [filter]="true"
                      filterBy="label"
                      (onChange)="onTimeZoneChange($event)"
                      appendTo="body"
                      [style]="{ width: '100%' }"
                      [virtualScroll]="true"
                      [virtualScrollItemSize]="30"
                    />
                  </span>
                </div>
                <div class="row-item">
                  <span class="label"
                    >{{ 'LOCATION.LABEL.CONTACT_LIST' | translate }}:</span
                  >
                  <span class="row-input">
                    <p-select
                      [options]="contactListsForDropdowns"
                      optionLabel="name"
                      optionValue="id"
                      [filter]="true"
                      filterBy="name"
                      formControlName="ContactListId"
                      appendTo="body"
                      [virtualScroll]="true"
                      [virtualScrollItemSize]="34"
                    />
                  </span>
                </div>
                <div class="row-item">
                  <span class="label"
                    >{{
                      'LOCATION.LABEL.MANAGEMENT_CONTACT_LIST' | translate
                    }}:</span
                  >
                  <span class="row-input">
                    <p-select
                      [options]="contactListsForDropdowns"
                      optionLabel="name"
                      optionValue="id"
                      [filter]="true"
                      filterBy="name"
                      formControlName="managementContactListId"
                      appendTo="body"
                      [virtualScroll]="true"
                      [virtualScrollItemSize]="34"
                    />
                  </span>
                </div>
                <div class="row-item">
                  <span class="label"
                    >{{ 'LOCATION.LABEL.SCADA_ID' | translate }}:</span
                  >
                  <span class="row-input">
                    <input
                      type="text"
                      pInputText
                      class="ui-inputtext ui-widget ui-state-default ui-corner-all ui-autocomplete-input"
                      formControlName="scadaId"
                      size="10"
                    />
                  </span>
                </div>
              </div>
            }
            <div class="row">
              <div class="row-item-long">
                <span class="label" id="notes-label"
                  >{{ 'LOCATION.LABEL.NOTES' | translate }}:</span
                >
                <span class="row-input">
                  <textarea
                    pTextarea
                    autoResize="autoResize"
                    class="ui-inputtext ui-widget ui-state-default ui-corner-all ui-autocomplete-input"
                    formControlName="notes"
                  ></textarea>
                </span>
              </div>
            </div>
          </div>
          <div id="facility-tab-view">
            <p-tabs (onChange)="tabChanged($event)" [value]="tabIndex">
              <p-tablist>
                <p-tab [value]="0">{{
                  'LOCATION.LABEL.FACILITY_TABS.CONTACT_LIST' | translate
                }}</p-tab>
                <p-tab [value]="1">{{
                  'LOCATION.LABEL.FACILITY_TABS.NOTEPAD' | translate
                }}</p-tab>
                <p-tab [value]="2">{{
                  'LOCATION.LABEL.FACILITY_TABS.NOTEPAD_ARCHIVE' | translate
                }}</p-tab>
                <p-tab [value]="3">{{
                  'LOCATION.LABEL.FACILITY_TABS.ADDITIONAL_RESOURCE_LIST'
                    | translate
                }}</p-tab>
              </p-tablist>
              <p-tabpanels>
                <p-tabpanel class="tab-panel" [value]="0">
                  @if (contactList || managementContactList) {
                    <app-facility-contact-list-embed
                      [contactList]="contactList"
                      [managementContactList]="managementContactList"
                    />
                  } @else {
                    {{
                      'CONTACT.MESSAGES.WARN.NO_CONTACT_LIST_FOR_FACILITY'
                        | translate
                    }}
                  }
                </p-tabpanel>
                <p-tabpanel class="tab-panel" [value]="1">
                  <app-facility-notepad
                    [facility]="facility"
                    [archivedStatus]="ArchivedEntryStatus.NonArchivedOnly"
                    (notepadChangedEvent)="onNotepadChange()"
                  />
                </p-tabpanel>
                <p-tabpanel class="tab-panel" [value]="2">
                  <app-facility-notepad
                    [facility]="facility"
                    [archivedStatus]="ArchivedEntryStatus.ArchivedOnly"
                    (notepadChangedEvent)="onNotepadChange()"
                  />
                </p-tabpanel>
                <p-tabpanel class="tab-panel" [value]="3">
                  @if (additionalResourceLists.length > 0 || isEditting) {
                    <app-facility-contact-list-embed
                      #embeddedContactLists
                      [additionalResourceLists]="additionalResourceLists"
                      [additionalResourceListTypes]="
                        additionalResourceListTypes
                      "
                      [contactListsForDropdowns]="contactListsForDropdowns"
                      [editMode]="isEditting"
                      (updateAdditionalResourceListEvent)="
                        updateAdditionalResourceList($event)
                      "
                      (removeAdditionalResourceListEvent)="
                        removeAdditionalResourceListEvent($event)
                      "
                    />
                  } @else {
                    <h4>
                      {{
                        'CONTACT.MESSAGES.WARN.NO_ADDITIONAL_RESOURCE_LISTS_FOR_FACILITY'
                          | translate
                      }}
                    </h4>
                  }
                </p-tabpanel>
              </p-tabpanels>
            </p-tabs>
          </div>
        </div>
      </form>
    </div>
  }
  @if (facility && states && counties && townships) {
    <app-locations-form
      [states]="states"
      [counties]="counties"
      [townships]="townships"
      [isVisible]="displayLocationsDialog"
      [facility]="facility"
      formTitle="Manage Locations"
      [locationType]="locationDialogType"
      (locationsHidden)="onLocationsDialogHidden()"
      (locationsUpdated)="onLocationsDialogUpdated($event)"
      #locationsForm
    />
  }
</blockable-div>
